export { getModulesApi, completeVideoApi } from './api/module.api';
export { getModuleReviewsApi } from './api/review.api';
export type { ModuleDTO } from './api/module.api';

export { codeSnippets } from './config/code';
export { plansOrder } from './config/plan';
export { videoMap } from './config/video';

export { useActiveModule } from './hooks/useActiveModule';

export {
  parseModuleDTO,
  getModulesChainLength,
  getBestModuleByChainLength,
  getModuleByPlan,
} from './lib/parsers';
export { generateModuleTOC } from './lib/toc';

export type * from './model/report';
export { useModuleStore } from './model/store';
export { ModuleLevel, ModuleType } from './model/types';
export type {
  TOCType,
  Module,
  QuizMeta,
  Syllabus,
  Review,
  TOC,
  ModulePrice,
  CodeSnippet,
  Video,
  Plan,
  PlaygroundFile,
} from './model/types';

export { default as VideoCard } from './ui/VideoCard/VideoCard';
export { default as PlaygroundCard } from './ui/PlaygroundCard/PlaygroundCard';
